import moment from 'moment'
import validate from 'validate.js'
(function() {
  
  var member_errors = {
     '1': 'Incorrect username or password.  Please try again.',
     '2': 'The username is required.',
     '3': 'The password is required.',
     '4': 'UserID-MemberID possible issue.  Please contact UHA Customer Services.',
     '5': 'Login restricted.  Please contact UHA Customer Services.'
  }
  var provider_errors = {
     '1': 'Incorrect username or password.  Please try again.',
     '2': 'The username is required.',
     '3': 'The password is required.',
     '4': 'UserID-MemberID possible issue.  Please contact UHA Customer Services.',
     '5': 'Login restricted.  Please contact UHA Customer Services.',
     '6': 'Your account is currently locked. It will unlock automatically in 10 minutes. Please try again.<br />If you continue to have problems accessing Online Provider Services, please contact UHA Customer Services for assistance.<p>'
  }

  validate.options = {
    fullMessages: false
  }
  validate.extend(validate.validators.datetime, {
    parse: function(value, options) {
      return +moment.utc(value);
    },
    format: function(value, options) {
      var format = options.dateOnly ? "YYYY-MM-DD" : "YYYY-MM-DD hh:mm:ss";
      return moment.utc(value).format(format);
    }
  });

  var constraints = {
    "username": {
      presence: {
        message: "required"
      }
    },
    "password": {
      presence: {
        message: "required"
      }
    },
  };

  var form = document.querySelector('form[class$="login-form"]');
  if(form !== null) {
    form.addEventListener("submit", function(ev) {
      ev.preventDefault();
      handleFormSubmit(form);
    });
    var messages = {};
    // Setup login error messages
    if(document.querySelector('form.member-login-form') !== null) {
        messages = member_errors;
    } else if(document.querySelector('form.provider-login-form') !== null) {
        messages = provider_errors;
    }
    var error_msg_el = document.querySelector('.error-message');
    var params = new URLSearchParams(window.location.search);
    var error  = params.get("msg");
    if(error !== null) {
        error_msg_el.innerHTML = messages[error]; 
    }
  }

  function handleFormSubmit(form, input) {
    // validate the form against the constraints
    var fields = form.querySelectorAll("input[name], select[name], textarea[name]"), i;
    
    var errors = validate(form, constraints);
    showErrors(form, errors || {});
    if (!errors) {
        form.submit();
    }
  }

  function showErrors(form, errors) {
    var fields = form.querySelectorAll("input[name], select[name], textarea[name]"), i;
    for (i = 0; i < fields.length; ++i) {
      showErrorsForInput(fields[i], errors && errors[fields[i].name]);
    }
  }

  function showErrorsForInput(input, errors) {
    if(input.name !== 'f' && input.name !== 't' && input.name !== 'success_message') {
      var formGroup = closestParent(input.parentNode, "frow");
      var messages = formGroup.querySelector(".messages");
      resetFormGroup(formGroup);
      if (errors) {
        formGroup.classList.add("has-error");
        for (var i = 0; i < errors.length; ++i) {
          addError(messages, errors[i]);
        }
      } else {
        formGroup.classList.add("has-success");
      }
    }
  }

  // Recusively finds the closest parent that has the specified class
  function closestParent(child, className) {
    if (!child || child == document) {
      return null;
    }
    if (child.classList.contains(className)) {
      return child;
    } else {
      return closestParent(child.parentNode, className);
    }
  }

  function resetFormGroup(formGroup) {
    formGroup.classList.remove("has-error");
    formGroup.classList.remove("has-success");
    var messages = formGroup.querySelectorAll(".help-block.error"), i;
    for (i = 0; i < messages.length; ++i) {
      messages[i].parentNode.removeChild(messages[i]);
    }
  }

  function addError(messages, error) {
    var block = document.createElement("p");
    block.classList.add("help-block");
    block.classList.add("error");
    block.innerText = error;
    messages.appendChild(block);
  }

  function showSuccess(form) {
    var success_message = form.querySelector('input[name="success_message"]').value;
    form.reset();
    var success_el = document.createElement("p");
    success_el.classList.add("help-block");
    success_el.classList.add("success");
    success_el.innerText = success_message;
    var frows  = form.querySelectorAll(".frow"), i;
    for (i = 0; i < frows.length; ++i) {
        frows[i].hidden = true;
    }
    form.querySelector('.faction').hidden = true;
    form.appendChild(success_el);
  }
})();
